<div class="content">
<div class="modal-header">
</div>
<accordion [isAnimated]="true" [closeOthers]="oneAtATime">
    <app-form-step [id]="id"></app-form-step>
</accordion>
</div>